export default __webpack_public_path__ + "static/media/add-icon.4c989fe5.svg";